import axiosClient from "../../../api/axios_client";

export const sendChatMessage = async (messages) => {
  const res = await axiosClient.post("ai-chatbot/chat", { messages });
  return res.data;
};
